const wrapper = "_uqxw1ltldr3";
const header = "_uqxh17yc8tj";
const title = "_uqxt1snm9i1";
const heading = "_uqxhnzo9af";
const headingDescription = "_uqxh1nfzjtq";
const collapseChevron = "_uqxc10onfpi";
const resetButton = "_uqxr1sbyq23";

export { collapseChevron, header, heading, headingDescription, resetButton, title, wrapper };
import "./component.style.linaria.module.css";
//# sourceMappingURL=component.style.js.map
